<template>
  <div class="main" id="main">
    <div class="matchList">
      <div class="backBox" >
        <div class="orgBox" v-for="(item,index) in showData.value" :key="index">
          <!-- 6人 -->
          <div v-if="index%3==0&&showData.value.length==6">
            <div class="orgName2">{{item.org}}</div>
            <div class="orgName4">{{item.playerName}}/{{showData.value[index+1].playerName}}/{{showData.value[index+2].playerName}}</div>
            <div class="orgName2">{{item.count}}</div>
            <div class="orgName2">{{item.totalScore}}</div>
          </div>
          <!-- 4人 -->
          <div v-if="index%2==0&&showData.value.length==4">
            <div class="orgName2">{{item.org}}</div>
            <div class="orgName4">{{item.playerName}}/{{showData.value[index+1].playerName}}</div>
            <div class="orgName2">{{item.count}}</div>
            <div class="orgName2">{{item.totalScore}}</div>
          </div>
          <!-- 2人 -->
          <div v-if="showData.value.length==2">
            <div class="orgName2">{{item.org}}</div>
            <div class="orgName2">{{item.playerName}}</div>
            <div class="orgName2">{{item.count}}</div>
            <div class="orgName2">{{item.currentCount}}</div>
          </div>
           <!-- 获胜金银牌 -->
          <div class="fixed fixedL"
         :class="{
            bronze:
              projectInfo.projectTypeName.indexOf('铜牌')!=-1 &&
              showData.value[0].isWinner == 1,
            gold:
              projectInfo.projectTypeName.indexOf('金牌')!=-1 &&
              showData.value[0].isWinner == 1,
            silver:
              projectInfo.projectTypeName.indexOf('金牌')!=-1 &&
              showData.value[0].isWinner == 0 &&
              showData.value[showData.value.length/2].isWinner == 1,
          }"
          ></div>
          <div class="fixed fixedR"
          :class="{
            bronze:
              projectInfo.projectTypeName.indexOf('铜牌')!=-1 &&
              showData.value[showData.value.length/2].isWinner == 1,
            gold:
              projectInfo.projectTypeName.indexOf('金牌')!=-1 &&
              showData.value[showData.value.length/2].isWinner == 1,
            silver:
              projectInfo.projectTypeName.indexOf('金牌')!=-1 &&
              showData.value[showData.value.length/2].isWinner == 0 &&
              showData.value[0].isWinner == 1,
          }"
          ></div>
        </div>
        
      </div>
      <!-- 2人 -->
      <div class="svgBox" v-for="(item,index) in showData.value" :key="index" >
        <div v-if="showData.value.length==2">
          <div class="targetContainer" style="height:5rem;">
            <div :class="{ shotType: item.sight == 1 }"></div>
            <div class="playerName"></div>
            <div class="name">{{item.playerName}}</div>
            <!-- <div class="playerscoreT">{{item.totalScore}}</div> -->
            <div class="playerscoreT">{{getScore(index)}}</div>
            <component v-if="item.eliminated != 2"
              v-bind:is="svgName"
              :dataitem="item.isSoff ? item.soffPosition : item.position"
              :lastscore="lastPosition(item,index)"
              ></component>
          </div>
        </div> 
      </div>
      <!-- 4人 6人 -->
      <div class="orgBox" v-for="(item,index) in showData.value" :key="index" >
        <!-- 6人 -->
        <div v-if="index%3==0&&showData.value.length==6">
          <!--  6人第一个 -->
          <div class="targetContainer">
            <div :class="{ shotType: item.sight == 1 }"></div>
            <div class="playerName"></div>
            <div class="name">{{item.playerName}}</div>
            <div v-if="item.position.length>0" class="playerscore">{{item.position[item.position.length-1].score}}</div>
            <component v-if="item.eliminated != 2"
              v-bind:is="svgName"
              :dataitem="item.isSoff ? item.soffPosition : item.position"
              :lastscore="lastPosition(item,index)"
              ></component>
          </div>
          <!--  6人第二个 -->
          <div class="targetContainer">
            <div :class="{ shotType: item.sight == 1 }"></div>
            <div class="playerName"></div>
            <div class="name">{{showName(index).playerName}}</div>
            <div v-if="showData.value[index+1].position.length>0" class="playerscore">{{getScore(index+1)}}</div>
            <component v-if="item.eliminated != 2"
              v-bind:is="svgName"
              :dataitem="showData.value[index+1].isSoff ? showData.value[index+1].soffPosition : showData.value[index+1].position"
              :lastscore="lastPosition(item,index+1)"
              ></component>
          </div>
          <!--  6人第三个 -->
          <div class="targetContainer">
            <div :class="{ shotType: item.sight == 1 }"></div>
            <div class="playerName"></div>
            <div class="name">{{showName(index+1).playerName}}</div>
            <div v-if="showData.value[index+2].position.length>0" class="playerscore">{{getScore(index+2)}}</div>
            <component v-if="item.eliminated != 2"
              v-bind:is="svgName"
              :dataitem="showData.value[index+2].isSoff ? showData.value[index+2].soffPosition : showData.value[index+2].position"
              :lastscore="lastPosition(item,index+2)"
              ></component>
          </div>
        </div>
        <!-- 4人 -->
        <div v-if="index%2==0&&showData.value.length==4">
          <!-- 4人第一个 -->
          <div class="targetContainer">
          <div :class="{ shotType: item.sight == 1 }"></div>
          <div class="playerName"></div>
            <div class="name">{{item.playerName}}</div>
            <div v-if="item.position.length>0" class="playerscore">{{getScore(index)}}</div>
            <!-- 
              :dataitem="datatime(index,item)" -->
            <component v-if="item.eliminated != 2"
              v-bind:is="svgName"
              :dataitem="item.isSoff ? item.soffPosition : item.position"
              :lastscore="lastPosition(item,index)"
              ></component>
          </div>
          <!-- 4人第二个 -->
          <div class="targetContainer">
            <div :class="{ shotType: item.sight == 1 }"></div>
            <div class="playerName"></div>
            <div class="name">{{showName(index).playerName}}</div>
            <div v-if="showData.value[index+1].position.length>0" class="playerscore">{{getScore(index+1)}}</div>
            <!-- <component v-if="item.eliminated != 2"
              v-bind:is="svgName"
              :dataitem="datatime(index+1,item)"
              :lastscore="lastPosition(item,index+1)"
              ></component> -->
              <component v-if="item.eliminated != 2"
              v-bind:is="svgName"
              :dataitem="showData.value[index+1].isSoff ? showData.value[index+1].soffPosition : showData.value[index+1].position"
              :lastscore="lastPosition(item,index+1)"
              ></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs,onMounted } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
import svgm10ar from "../../components/10m/svg10mAR.vue"
import svgm10ap from "../../components/10m/svg10mAP.vue"
var opt;
export default {
  components: {  svgm10ar, svgm10ap  },
  setup(props,{refs,root}) {
    const showData = props.showData
    const svgName = props.svgName
    return {
      showData,
      svgName,
      projectInfo: reactive(createState).projectInfo,
    };
  },
  props: {  //指定接收的值，必须指定类型
    showData: Object,
    svgName:String
  },
  methods: {
    //获取运动员最新一发成绩
    getScore(index){
      if(this.showData.value.length>0){
        const positionlength = this.showData.value[index].position.length-1
        if(positionlength>=0){
          const showScore = this.showData.value[index].position[positionlength].score
          return showScore
        }else{
          return
        }
      }
    },
    //将弹着数据传入靶盘组件
    datatime(index,item){
      if(this.showData.value.length!=index){
        const  list = []
        if (item.isSoff) {
          if(this.showData.value[index].soffPosition[0]){
            list.push({ ...this.showData.value[index].soffPosition[0] });
          }
          return list;
        } else {
          if(this.showData.value[index].position[0]){
            list.push({ ...this.showData.value[index].position[0] });
          }
          return list;
        }
      }
    },
    showName(index){
      if(this.showData.value.length!=index){
        return  this.showData.value[index+1]
      }
    },
    lastPosition(item,index) {
      const data = this.showData.value[index].isSoff ? this.showData.value[index].soffPosition : this.showData.value[index].position;
      if (data.length > 0) {
        let position = data[data.length - 1];
        return position.score;
      } else {
        return "";
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.backBox{
  width: 100%;
  height: 4rem;
  background-image: url('./back.jpeg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.targetContainer2{
  width: 100%;
  height: 5rem;
  transform: scale(var(--transScale));
  margin-top: var(--margin);
  box-sizing: border-box;
  border: 2px solid white;
  background:white;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}
.targetContainer{
  width: 100%;
  height: 4rem;
  transform: scale(var(--transScale));
  margin-top: var(--margin);
  box-sizing: border-box;
  border: 2px solid white;
  background:white;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  
}
.name{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    font-weight: 700;
    font-size: 0.5rem;
    color: #fff;
    text-align: left;
    text-indent: 0.2rem;
  }
  .playerscoreT{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    font-weight: 700;
    font-size: 0.5rem;
    color: #fff;
    // text-align: right;
    text-indent: 6rem;
    padding-right: 0.3rem;
    box-sizing: border-box;
  }
  .playerscore{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    font-weight: 700;
    font-size: 0.5rem;
    color: #fff;
    text-align: right;
    // text-indent: 2rem;
    padding-right: 0.3rem;
    box-sizing: border-box;
  }
  .playerName{
    z-index: 2;
    width: 100%;
    height: 1rem;
    background-color:#333399; 
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
  }
.orgName2{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.5rem;
  color: #fff;
  overflow: hidden;
}
.orgName4{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.4rem;
  color: #fff;
  overflow: hidden;
}.orgName6{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.3rem;
  color: #fff;
  overflow: hidden;
}
.totalScore{
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.4rem;
}
.count{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.6rem;
  color: #FF0033;
  background-color:#99CCFF; 
}
.matchList {
  flex: 1;
  height: auto;
  width: 100%;
  background: #fff;
  position: relative;
  .orgBox{
    width: 50%;
    height: auto;
    float: left;
  }
  .svgBox{
    width: 100%;
    height: auto;
    float: left;
  }
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  height: 1rem;
  position: fixed;
    background: #fff;
    z-index: 2;
    border-bottom: 1px solid #333;
  .title{
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis{
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
    }
  }
}

.QF{
  background-color: red;
  color: #fff;
}

</style>